//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    primaryKey: {
      type: String,
      default: 'id'
    },
    selectedItemsIds: {
      type: Array,
      default () {
        return []
      }
    },
    disabledItemsIds: {
      type: Array,
      default () {
        return []
      }
    },
    height: {
      type: Number,
      default: 400
    },
    rowsPerPage: {
      type: Number,
      default: 10
    }
  },
  data: function () {
    return {
      selectedItemsIdsLocal: [],
      selected: [],

      pagination: {
        page: 1,
        rowsPerPage: this.rowsPerPage
      }
    }
  },
  watch: {
    selectedItemsIds: function (result) {
      this.selectedItemsIdsLocal = result
      this.updateSelections()
    }
  },
  created: function () {
    this.selectedItemsIdsLocal = this.selectedItemsIds ? [...this.selectedItemsIds] : []
    this.updateSelections()
  },
  methods: {
    updateSelections: function () {
      for (let i = 0; i < this.items.length; i++) {
        if (this.itemIsSelected(this.items[i])) {
          this.$set(this.items[i], 'isChecked', true)
        } else {
          this.$set(this.items[i], 'isChecked', false)
        }
      }
    },
    itemIsSelected: function (item) {
      for (let i = 0; i < this.selectedItemsIdsLocal.length; i++) {
        if (item[this.primaryKey] == this.selectedItemsIdsLocal[i]) {
          return true
        }
      }

      return false
    },
    itemIsDisabled: function (item) {
      for (let i = 0; i < this.disabledItemsIds.length; i++) {
        if (item[this.primaryKey] == this.disabledItemsIds[i]) {
          return true
        }
      }

      return false
    },
    selectTableItem: function (item) {
      if (this.itemIsDisabled(item)) {
        return
      }

      let itemIndex = -1

      for (let i = 0; i < this.selectedItemsIdsLocal.length; i++) {
        if (this.selectedItemsIdsLocal[i] == item[this.primaryKey]) {
          itemIndex = i
          break
        }
      }

      if (itemIndex == -1) {
        this.selectedItemsIdsLocal.push(item[this.primaryKey])
      } else {
        this.selectedItemsIdsLocal.splice(itemIndex, 1)
      }

      this.$emit('selected-items-ids', this.selectedItemsIdsLocal)
    }
  }
}

